module.exports = __webpack_public_path__ + "37ed7d2ce42d7875d89d9063f7a00787.jpg";